export const base = {
    store: {
		list: '/stores',
		create: '/stores/create',
		update: '/stores/update',
		view: '/stores/view',
		destroy: '/stores/destroy'
	},
	dept: {
		list: '/departments',
		create: '/departments/create',
		update: '/departments/update',
		view: '/departments/view',
		destroy: '/departments/destroy'
	},
	user: {
		list: '/users',
		create: '/users/create',
		update: '/users/update',
		view: '/users/view',
		destroy: '/users/destroy'
	},
	shipper: {
		list: '/shippers',
		create: '/shippers/create',
		update: '/shippers/update',
		view: '/shippers/view',
		destroy: '/shippers/destroy'
	},
	role: {
		list: '/user-roles',
		create: '/user-roles/create',
		update: '/user-roles/update',
		view: '/user-roles/view',
		destroy: '/user-roles/destroy'
	},
	complaint: {
		list: '/complaints',
		create: '/complaints/create',
		update: '/complaints/update',
		view: '/complaints/view',
		destroy: '/complaints/destroy',
		new: '/complaints/new',
		processing: '/complaints/processing',
		completed: '/complaints/completed',
		closed: '/complaints/closed',
		reopen: '/complaints/reopen',
		overdue: '/complaints/overdue',
		trashed: '/complaints/trashed',
	},
	memberRegister: {
		list: '/member-register',
		create: '/member-register/create',
		update: '/member-register/update',
		view: '/member-register/view',
		destroy: '/member-register/destroy'
	},
	vatInfo: {
		list: '/vat-info',
		create: '/vat-info/create',
		update: '/vat-info/update',
		view: '/vat-info/view',
		destroy: '/vat-info/destroy'
	},
	goodsRefund: {
		list: '/goods-refund',
		create: '/goods-refund/create',
		update: '/goods-refund/update',
		view: '/goods-refund/view',
		destroy: '/goods-refund/destroy'
	},
	goodsDelivery: {
		list: '/goods-delivery',
		create: '/goods-delivery/create',
		update: '/goods-delivery/update',
		view: '/goods-delivery/view',
		destroy: '/goods-delivery/destroy'
	},
	supplierStaff: {
		list: '/supplier-staffs',
		create: '/supplier-staffs/create',
		update: '/supplier-staffs/update',
		view: '/supplier-staffs/view',
		destroy: '/supplier-staffs/destroy'
	},
	supplierStaffChecking: {
		list: '/checkin',
		create: '/checkin/create',
		update: '/checkin/update',
		view: '/checkin/view',
		destroy: '/checkin/destroy'
	},
	productPromotion: {
		list: '/product-promotions',
		create: '/product-promotions/create',
		update: '/product-promotions/update',
		view: '/product-promotions/view',
		destroy: '/product-promotions/destroy'
	},
	productPromotionHistory: {
		list: '/product-promotion-history',
		create: '/product-promotion-history/create',
		update: '/product-promotion-history/update',
		view: '/product-promotion-history/view',
		destroy: '/product-promotion-history/destroy'
	},
	task: {
		list: '/task-management',
		create: '/task-management/create',
		update: '/task-management/update',
		view: '/task-management/view',
		destroy: '/task-management/destroy'
	},
	masterCompany: {
		list: '/master-company',
		create: '/master-company/create',
		update: '/master-company/update',
		view: '/master-company/view',
		destroy: '/master-company/destroy'
	},
	priceChecking: {
		list: '/price-checking',
		create: '/price-checking/create',
		update: '/price-checking/update',
		view: '/price-checking/view',
		destroy: '/price-checking/destroy'
	},
	revenueForecast: {
		list: '/revenue-forecast'
	},
	giftCardEvents: {
		list: '/gift-card-events',
		create: '/gift-card-events/create',
		update: '/gift-card-events/update',
		view: '/gift-card-events/view',
		destroy: '/gift-card-events/destroy'
	},
	giftCardEventProducts: {
		list: '/gift-card-event-products',
		create: '/gift-card-event-products/create',
		update: '/gift-card-event-products/update',
		view: '/gift-card-event-products/view',
		destroy: '/gift-card-event-products/destroy'
	},
	giftCardEventLogs: {
		list: '/gift-card-event-logs',
		create: '/gift-card-event-logs/create',
		update: '/gift-card-event-logs/update',
		view: '/gift-card-event-logs/view',
		destroy: '/gift-card-event-logs/destroy'
	},
	customerSurrveyResponses: {
		list: '/customer-survey-responses',
		create: '/customer-survey-responses/create',
		update: '/customer-survey-responses/update',
		view: '/customer-survey-responses/view',
		destroy: '/customer-survey-responses/destroy'
	},
	events: {
		list: '/events',
		create: '/events/create',
		update: '/events/update',
		view: '/events/view',
		destroy: '/events/destroy'
	},
	eventProducts: {
		list: '/event-products',
		create: '/event-products/create',
		update: '/event-products/update',
		view: '/event-products/view',
		destroy: '/event-products/destroy'
	},
	eventLogs: {
		list: '/event-logs',
		create: '/event-logs/create',
		update: '/event-logs/update',
		view: '/event-logs/view',
		destroy: '/event-logs/destroy'
	},
	setting:{
		profile: "/profile-setting"
	},
	notFound: "/not-found",
	routeId: {
		ticket: "ticket",
		complaints: "complaints",
		report: "report",
		system: "system",
		stores: "stores",
		users: "users",
		shippes: "shippers",
		departments: "departments",
		userRoles: "user-roles",
		registerDictionary: "register-dictionary",
		memberRegister: "register-dictionary",
		vatInfo: "vat-info",
		vatDetail: "vat-get-info",
		goodsRefund: "register-dictionary",
		goodsDelivery: "goods-delivery",
		supplierStaff: "supplier-staffs",
		supplierStaffChecking: "supplier-staffs-checking",
		masterCompany: "master-company",
		priceChecking: "price-checking",
		revenueForecast: "revenue-forecast",
		productPromotions: "product-promotions",
		giftCardEvents: "gift-card-events",
		giftCardEventProducts: "gift-card-event-products",
		giftCardEventLogs: "gift-card-event-logs",
		events: "events",
		eventProducts: "event-products",
		eventLogs: "event-logs",
		task: "task-management",
		customerSurrveyResponses: "customer-survey-responses",
	},
	roleAuth:{
		add: "add",
		edit: "edit",
		delete: "delete",
		read: "read",
		report: "report",
		other: "other",
	}
}
export default base;